import { render, staticRenderFns } from "./ProductsSubmenu.vue?vue&type=template&id=0a0bbea9"
import script from "./ProductsSubmenu.vue?vue&type=script&lang=js"
export * from "./ProductsSubmenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports